<div class="banner">
  <div i18n class="title-text">
    Updates pending. The information in this section does not reflect any change requests.
  </div>
  <div i18n class="sub-text">{{ subText }}</div>
  <div *ngIf="isInternal$ | async; else memberLink" i18n class="sub-text">
    You can view the requested changes <span class="button" (click)="linkClicked.emit()">here.</span>
  </div>
  <ng-template #memberLink>
    <div i18n class="sub-text">
      You can view your requested changes <span class="button" (click)="linkClicked.emit()">here.</span>
    </div>
  </ng-template>
</div>
